import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import MFormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { IMultitextInput } from "../../constants/model-interfaces";
import MultitextField from "./MultitextField";

const Multitext = (props: IProps) => {
    const [inputs, setInputs] = useState<Array<IMultitextInput>>([]);
    const [value, setValue] = useState(props.value);

    useEffect(() => {
        const inputs: Array<IMultitextInput> = [];
        const strValue = props.value + "";
        const regParts = strValue.split(props.seperator);
        props.inputs.forEach((input, index) => {
            input.value = regParts && regParts[index] ? regParts[index] : "";
            inputs.push(input);
        });
        setInputs(inputs);
    }, [props.inputs, props.value]);

    const updateValue = (value: string, updateIndex: number) => {
        const values = inputs.map((input, index) => (updateIndex === index ? value : input.value));
        const actualValue = values.join(props.seperator);
        props.updateValue(actualValue);
    };

    return (
        <MFormControl className={"meta-multitext " + props.wrapperClassName} fullWidth size={props.size} variant={props.variant}>
            <InputLabel className='meta-multitext-label'>{props.displayLabel}</InputLabel>
            <div className='row'>
                {inputs &&
                    inputs.map((input: IMultitextInput, index: number) => (
                        <MultitextField key={index} input={input} placeholder={props.placeholder} update={(val: string) => updateValue(val, index)} />
                    ))}
            </div>
        </MFormControl>
    );
};

interface IProps {
    displayLabel: string;
    placeholder: string | undefined;
    inputs: Array<IMultitextInput>;
    value: string | number | boolean | undefined;
    variant: any;
    seperator: string;
    size: any;
    updateValue: Function;
    wrapperClassName: string;
}

export default Multitext;
